<template>
  <el-select
    v-model="selectedValue"
    @change="emitChange()"
    :loading="loading"
    ref="generic-select"
    :no-match-text="noMatchingText"
    :multiple="multiple"
    :disabled="disabled"
    filterable
  >
    <el-option
      v-for="item in list"
      :key="item[valueField]"
      :label="item[labelField]"
      :value="item[valueField]"
      :disabled="item.disabled"
    ></el-option>
  </el-select>
</template>

<script>
import selectService from '@/api/selectService';

export default {
  name: 'LoadNumberSelect',
  props: {
    value: {
      default: null
    },
    /* End Point Url to search data. */
    url: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be show in the options of the list. */
    labelField: {
      type: String,
      default: null
    },
    /* The attribute name of item that must be updated the model. */
    valueField: {
      type: String,
      default: null
    },
    /* The parameters that will be send with the url. */
    getParams: {
      type: Object,
      default: null
    },
    /* usually the select will be loaded with values that are not used,
     so the current value will not appear in the list and therefore we must add it. */
    currentValueObject: {
      type: Object,
      default: null
    },
    noMatchingText: {
      type: String,
      default: null
    },
    defaultAll: {
      type: Boolean,
      default: false
    },
    /* Default auto search is in true, for some components if we need additional data in getParams
    that is not ready on mounted then we need to put autosearch in false until we will have getParams,
    the get params changes performs an autosearch.
    */
    autoSearch: {
      type: Boolean,
      default: true
    },
    /* If the select is multiple or not. */
    multiple: {
      type: Boolean,
      default: false
    },
    /* This prop is temporary, it is used to allow the select to have a list of ids
     that are allowed to be selected. This change will remains until create the  workflow in
     the backend */
    allowedIds: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    emptyValue: {
      type: Boolean,
      default: false
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.selectedValue = newVal;
      },
      immediate: true
    },
    getParams() {
      if (!this.autoSearch) {
        this.search();
      }
    }
  },
  data() {
    return {
      selectedValue: this.value,
      list: [],
      loading: false
    };
  },
  mounted() {
    if (this.data && Array.isArray(this.data)) {
      // Si hay data local, úsala
      this.list = this.defaultAll
        ? [{ [this.labelField]: 'All', [this.valueField]: null }, ...this.data]
        : [...this.data];
      if (this.emptyValue) {
        this.list = [{ [this.labelField]: '', [this.valueField]: null }, ...this.list];
      }
      this.loading = false;
    } else if (this.autoSearch) {
      this.search();
    }
  },
  methods: {
    emitChange() {
      this.$emit('update:value', this.selectedValue);
      this.$emit('change', this.selectedValue);
    },
    search() {
      if (this.data && Array.isArray(this.data)) {
        // Si hay data local, no busques remoto
        this.list = this.defaultAll
          ? [{ [this.labelField]: 'All', [this.valueField]: null }, ...this.data]
          : [...this.data];
        if (this.emptyValue) {
          this.list = [{ [this.labelField]: '', [this.valueField]: null }, ...this.list];
        }
        this.loading = false;
        this.checkSelectedValueAfterSearch();
        return;
      }
      if (this.currentValueObject && this.currentValueObject.trailer_id) {
        this.list.push(this.currentValueObject);
      }
      this.loading = true;
      selectService.getList(this.url, this.getParams).then((response) => {
        if (response instanceof Array) {
          this.fillList(response);
        } else if (response.data && response.data instanceof Array) {
          // We will filter the response to include only the allowed ids if they are provided. (Temporary solution)
          this.fillList(response.data);
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    fillList(arrayData) {
      if (arrayData.length === 0 && this.currentValueObject && this.currentValueObject[this.labelField]) {
        this.list = [this.currentValueObject];
      } else {
        this.list = [];
      }
      if (this.allowedIds && this.allowedIds.length > 0) {
        arrayData = arrayData.filter(item => this.allowedIds.includes(item.id));
      }
      if (this.defaultAll) {
        this.list = [...this.list, ...arrayData];
      } else {
        this.list = [...arrayData];
      }
      if (this.emptyValue) {
        this.list = [{ [this.labelField]: '', [this.valueField]: null }, ...this.list];
      }

      this.loading = false;
      this.checkSelectedValueAfterSearch();
    },
    checkSelectedValueAfterSearch() {
      // We check if the selected value is on list, otherwise we clear it.
      if (this.multiple) {
        if (this.value && this.value.length > 0) {
          this.selectedValue = this.value.filter(item => (this.list.some(listItem => (item === listItem[this.valueField]))));
          this.emitChange();
        }
      } else if (this.selectedValue && !this.list.some(item => (this.selectedValue === item[this.valueField]))) {
        this.selectedValue = null;
        this.emitChange();
      }
    },
    clearLocalModel() {
      this.selectedValue = null;
    },
    setLocalModel(val) {
      this.selectedValue = val;
      this.emitChange();
    }
  }
};
</script>
